angular.module('clientDashboardApp').directive('imageAdapt', ['$window','browserService', function ($window, browserService) {

  return function (scope, element, attrs) {

    var isIE = browserService.isMSIE();

    if(isIE){
      var w = angular.element($window);
      var imgSize = null;
      w.bind('resizeEnd', function() {
        addImageClasses(element);
      });
    }

    function nativeImgDimensions(img) {
      var i = new Image();
      i.src = img.src;
      return {
        width: i.width,
        height: i.height
      };
    }

    function getParentDimensions(el){
      return {
        width: $(el).parent().innerWidth(),
        height: $(el).parent().innerHeight()
      }
    }

    function smallerThanParent(childDims,parentDims){
      return childDims.width < parentDims.width && childDims.height < parentDims.height;
    }

    function childToParentAspectRatio(childDims,parentDims){
      return (childDims.width/childDims.height)/(parentDims.width/parentDims.height);
    }

    function addImageClasses($this){
      var classes = "";
      if(isIE){
        if(!imgSize){
          imgSize = nativeImgDimensions($this);
        }
        var contSize = getParentDimensions($this);
        $($this).removeClass("full-width full-height height-auto width-auto");
        if(smallerThanParent(imgSize,contSize)){
          var c2PAR = childToParentAspectRatio(imgSize,contSize)
          var constrainedSide = c2PAR >= 1 ? "width" : "height";
          var classTxt1 = "";
          var classTxt2 = "";
          classTxt1 = constrainedSide=="width" ? "width" : "height";
          classTxt2 = constrainedSide=="width" ? "height" : "width";
          classes = 'full-'+classTxt1+' '+classTxt2+'-auto';
        }
      }
      else {
        classes = "img-contain";
      }
      $($this).addClass(classes);
    }

    $(element).load(function(){
      addImageClasses(this);
    });
  }
}]);
